<template>
  <div class="vp-expander expenses-border">
    <div
      class="dropdown-field -ml-2 triple-f"
      tabindex="0"
      @click="toggleExpenseOpen"
    >
      <ChevronUp
        v-if="opened"
        class="arrow"
      />
      <ChevronDown
        v-else
        class="arrow"
      />
      <slot name="label">
        <span class="bold">{{ label }}</span>
      </slot>
    </div>
    <div v-show="opened">
      <slot name="expanded">
        Expanded
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ChevronUp, ChevronDown } from 'mdue';

const opened = ref<boolean>(false);

const toggleExpenseOpen = () => {
  opened.value = !opened.value;
};

interface Props {
  label?: string;
}

withDefaults(defineProps<Props>(), {
  label: 'Expanded label',
});
</script>
